import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import getLang from 'I18n/utils/getLang';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useRef } from 'react';
import debounce from 'react-utils/debounce';
import { GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY as PUBLIC_GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY } from '../../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY } from '../../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
import { useLazyAppContextQuery } from '../../../hooks/useAppContextQuery';
import { useFilterConfig } from '../../hooks/useFilterConfig';
import { useSupportedListingOptions } from '../../hooks/useSupportedListingOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SupportedListingsFilter() {
  const params = useSearchParams();
  const {
    PROFILE_SUPPORTED_LISTINGS
  } = useFilterConfig();
  const [fetch] = useLazyAppContextQuery({
    app: GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY,
    public: PUBLIC_GET_PAGINATED_SEARCH_FILTER_OPTIONS_QUERY
  });
  const listingIds = params.getList('PROFILE_SUPPORTED_LISTINGS');
  const supportedListingOptions = useSupportedListingOptions(listingIds);

  // prevents spamming the API for every char typed
  const debouncedFetch = debounce(fetch, 250);

  // determines when to reset things
  const prevInputRef = useRef('');

  // stores the data from previous paginated calls. reset when input changes
  const accumulatedOptionsRef = useRef([]);
  if (!PROFILE_SUPPORTED_LISTINGS) return undefined;
  const {
    label,
    field,
    placeholder
  } = PROFILE_SUPPORTED_LISTINGS;
  return /*#__PURE__*/_jsxs("div", {
    children: [label && /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: `eco_${field}`,
      children: label
    }), /*#__PURE__*/_jsx(Select, {
      filterOptions: false,
      id: `eco_${field}`,
      loadOptions: (input, callback, pagination) => {
        var _pagination$page;
        debouncedFetch({
          variables: {
            field: field,
            language: getLang(),
            page: (_pagination$page = pagination === null || pagination === void 0 ? void 0 : pagination.page) !== null && _pagination$page !== void 0 ? _pagination$page : 0,
            search: input
          },
          onCompleted: data => {
            var _data$result$nextPage;
            if (input !== prevInputRef.current) {
              prevInputRef.current = input;
              accumulatedOptionsRef.current = data.result.options;
            } else {
              accumulatedOptionsRef.current = [...accumulatedOptionsRef.current, ...data.result.options];
            }
            callback(null, {
              options: accumulatedOptionsRef.current,
              pagination: {
                hasMore: data.result.hasMoreOptions,
                length: data.result.total,
                page: (_data$result$nextPage = data.result.nextPage) !== null && _data$result$nextPage !== void 0 ? _data$result$nextPage : 0
              }
            });
          }
        });
      },
      multi: true,
      onChange: e => params.setList(field, e.target.value),
      options: supportedListingOptions,
      placeholder: placeholder,
      value: params.getList(field)
    })]
  });
}